import { useContext } from 'react';
import { StepContext, StepContextProps } from './contexts';

const defaultFn = (): void => {};

const useStep = ({ onPrev = defaultFn, onNext = defaultFn } = {}): StepContextProps => {
  const stepContext = useContext(StepContext) as StepContextProps;

  if (onPrev) {
    stepContext.onPrev.current = onPrev;
  }

  if (onNext) {
    stepContext.onNext.current = onNext;
  }

  return stepContext;
};

export { useStep };
